import React from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import css from './index.module.scss';
import { useRouter } from 'next/router';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useGlobal } from '@/utils/useGlobal';
import BenefitPoint1 from '../Svg/BenefitPoint1';
import BenefitPoint2 from '../Svg/BenefitPoint2';
import BenefitPoint3 from '../Svg/BenefitPoint3';
import BenefitPoint4 from '../Svg/BenefitPoint4';
import BenefitPointTime from '../Svg/BenefitPointTime';
import BenefitTimeLineH5 from '../Svg/BenefitTimeLineH5';
import BenefitTimeLine from '../Svg/BenefitTimeLine';

import styles from './index.module.scss';

interface IData {
    text: string;
    link?: string;
    icon: JSX.Element;
    view_more?: string;
    view_link_text?: string;
    onClick?: () => void;
}

const HIDE_DESC_LOCALES = ['it', 'es'];

const BenefitPoint: React.FC<any> = () => {
    const { useLang, useState, Link } = useGlobal();
    const { t } = useLang('ecocredits.benefits_points');
    const { locale } = useRouter();

    return (
        <div className={styles.benefit_point_container}>
            <div className="benefit_point_box">
                <Swiper
                    className="point-swiper"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        draggable: true,
                    }}
                >
                    <SwiperSlide className="point-slide">
                        <div className="time-line-container time-line-container-pc">
                            <BenefitTimeLine />
                        </div>
                        <div className="time-line-container time-line-container-h5">
                            <BenefitTimeLineH5 />
                        </div>
                        <div className="point-item">
                            <div className="point-time">
                                <p>{t('start_time_1')}</p>
                                <p>|</p>
                                <p>{t('end_time_1')}</p>
                                <div className="time-circle">
                                    <BenefitPointTime />
                                </div>
                            </div>
                            <div className="point-content">
                                <div className="point-info-box">
                                    <p className="point-title">{t('card_title_1')}</p>
                                    <p className="point-desc">{t('card_desc_1')}</p>
                                </div>

                                <p className="point-icon">
                                    <BenefitPoint1 />
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="point-slide">
                        <div className="point-item">
                            <div className="point-time">
                                <p>{t('start_time_2')}</p>
                                <p>|</p>
                                <p>{t('end_time_2')}</p>
                                <div className="time-circle">
                                    <BenefitPointTime />
                                </div>
                            </div>
                            <div className="point-content">
                                <div className="point-info-box">
                                    <p className="point-title">{t('card_title_2')}</p>
                                    <p className="point-desc">{t('card_desc_2')}</p>
                                </div>
                                <p className="point-icon">
                                    <BenefitPoint2 />
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="point-slide">
                        <div className="point-item">
                            <div className="point-time">
                                <p>{t('start_time_3')}</p>
                                <p>|</p>
                                <p>{t('end_time_3')}</p>
                                <div className="time-circle">
                                    <BenefitPointTime />
                                </div>
                            </div>
                            <div className="point-content">
                                <div className="point-info-box">
                                    <p className="point-title">{t('card_title_3')}</p>
                                    <ul className="point-desc point-desc-ul">
                                        <li>{t('card_desc_3_1')}</li>
                                        {HIDE_DESC_LOCALES.includes(locale as any) ? null : <li>{t('card_desc_3_2')}</li>}
                                    </ul>
                                </div>
                                <p className="point-icon">
                                    <BenefitPoint3 />
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="point-slide">
                        <div className="point-item">
                            <div className="point-time">
                                <p>{t('start_time_4')}</p>
                                <p>|</p>
                                <p>{t('end_time_4')}</p>
                                <div className="time-circle">
                                    <BenefitPointTime />
                                </div>
                            </div>
                            <div className="point-content">
                                <div className="point-info-box">
                                    <p className="point-title">{t('card_title_4')}</p>
                                    <ul className="point-desc point-desc-ul">
                                        <li>{t('card_desc_4_1')}</li>
                                        <li>{t('card_desc_4_2')}</li>
                                    </ul>
                                </div>
                                <p className="point-icon">
                                    <BenefitPoint4 />
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
            <div className="ecocredits-over" />
        </div>
    );
};

export default BenefitPoint;
